var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"ts-py-24 ts-bg-no-repeat ts-bg-cover",style:({
      'background-image':
        'url(' + require('@/assets/front/images/inner-page-bg.jpg') + ')'
    })},[_c('div',{staticClass:"ts-container ts-mx-auto ts-px-4"},[_c('h2',{staticClass:"ts-text-4xl sm:ts-text-6xl",class:_vm.$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font'},[_vm._v(_vm._s(_vm.$t('menu.result')))]),_c('ts-breadcrumb',{staticClass:"ts-text-base",class:_vm.$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot',attrs:{"items":[
        { text: _vm.$t('home'), href: '/' },
        {
          text: _vm.$t('menu.result'),
          active: true
        }
      ]}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }